import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { NbMenuService } from "@nebular/theme";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChatService } from "../../../@shared/services/chat.service";
import { AppComponent } from "../../../app.component";
import { Router } from "@angular/router";
import { SV_URL } from "../../../@core/utils/utils";
import { HttpClient } from "@angular/common/http";
import { CredentiaisService } from "../../../@core/utils/credentials.service";
import { WebsocketService } from "../../../@shared/services/webSocket.service";
import { PermissionService } from "../../../@core/services/permission.service";
import { TarefasProvider } from "../../../@shared/services/tarefas.service";

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  userMenu = [{ title: "Profile" }, { title: "Log out" }];
  userName: string = this.credentials.getUser();

  currentTheme = "default";

  newMsg: boolean = false;
  novaMsg = "";
  astral: boolean = false;
  lanc: boolean = false;
  vend: boolean = false;
  rela: boolean = false;
  gest: boolean = false;
  camb: boolean = false;
  descarga: boolean = false;

  ambiente = SV_URL;
  tarefasPendentes = false;

  constructor(
    private menuService: NbMenuService,
    public router: Router,
    public chat: ChatService,
    public home: AppComponent,
    public http: HttpClient,
    private credentials: CredentiaisService,
    private wsService: WebsocketService,
    private tarefasProvider: TarefasProvider,
    private cdr: ChangeDetectorRef,
    private permissionService: PermissionService,
  ) {}

  ngOnInit() {
    if (this.ambiente.indexOf("localhost") > 0) {
      this.ambiente = "LOCAL";
    } else {
      this.ambiente = "";
    }

    this.wsService.connect();
    this.wsService.messageEvents$.pipe(takeUntil(this.destroy$)).subscribe((msg) => {
      if (msg?.text?.["to"] === this.credentials.getUser()) {
        this.newMsg = true;
        this.novaMsg = "Nova";
        this.cdr.markForCheck();
      }
    });

    this.wsService.taskEvents$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.buscarTarefas();
    });

    this.home.carregarMenus();
    this.buscarTarefas();

    this.vend = this.permissionService.hasPermission('vendas.header');
    this.lanc = this.permissionService.hasPermission('lancamentos.header');
    this.rela = this.permissionService.hasPermission('relatorios.header');
    this.gest = this.permissionService.hasPermission('gestao.header');
    this.camb = this.permissionService.hasPermission('cambio.header');
    this.astral = this.permissionService.hasPermission('astral.header');
    this.descarga = this.permissionService.hasPermission('descarga.header');
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  goToMsg() {
    this.router.navigate(["/pages/messages/msg"]);
  }

  navegar(rota) {
    this.router.navigate([rota]);
  }

  logOut() {
    sessionStorage.removeItem("portal");
    sessionStorage.removeItem("uid");
    sessionStorage.removeItem("x");
    this.router.navigate(["/pages/authLogin/login"]).then(() => {
      window.location.reload();
    });
  }

  buscarTarefas() {
    const user = this.credentials.getUser();
    if (!user) {
      return;
    }
    this.tarefasProvider.getTarefasPendentes(user).pipe(takeUntil(this.destroy$)).subscribe({
      next: (data) => {
        this.tarefasPendentes = !!(data && data.length > 0);
        this.cdr.markForCheck();
      },
    });
  }
}
